import { render } from "./subscription.vue?vue&type=template&id=05beca13&scoped=true"
import script from "./subscription.vue?vue&type=script&lang=js"
export * from "./subscription.vue?vue&type=script&lang=js"

import "./subscription.vue?vue&type=style&index=0&id=05beca13&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05beca13"]])

export default __exports__